import CookieConsent from "components/CookieConsent";
import KoPage from "components/KoPage";
import OkDevolutionPage from "components/OkDevolutionPage";
import OkPage from "components/OkPage";
import { _renderLoading } from "components/SectionSliderProductCard";
import AccountAddresses from "containers/AccountPage/AccountAddresses";
import AccountBilling from "containers/AccountPage/AccountBilling";
import AccountOrder from "containers/AccountPage/AccountOrder";
import AccountPage from "containers/AccountPage/AccountPage";
import AccountPass from "containers/AccountPage/AccountPass";
import AccountRemove from "containers/AccountPage/AccountRemove";
import AccountSavelists from "containers/AccountPage/AccountSavelists";
import AccountStudents from "containers/AccountPage/AccountStudents";
import BlogPage from "containers/BlogPage/BlogPage";
import BlogSingle from "containers/BlogPage/BlogSingle";
import CollegeSignUp from "containers/CollegeSignUp";
import FaqsPage from "containers/FaqsPage";
import Page404 from "containers/Page404/Page404";
import PageAbout from "containers/PageAbout/PageAbout";
import CheckoutPage from "containers/PageCheckout/CheckoutPage";
import PageCollection from "containers/PageCollection";
import PageContact from "containers/PageContact/PageContact";
import PageForgotPassword from "containers/PageForgotPassword/PageForgotPassword";
import PageHome from "containers/PageHome/PageHome";
import PageLogin from "containers/PageLogin/PageLogin";
import PagePromotions from "containers/PagePromotions";
import PageSearch from "containers/PageSearch";
import PageSignUp from "containers/PageSignUp/PageSignUp";
import PageSubcription from "containers/PageSubcription/PageSubcription";
import CommonPoliticsPage from "containers/PoliticsPages/CommonPoliticsPage";
import CartPage from "containers/ProductDetailPage/CartPage";
import GroupedDetailPage from "containers/ProductDetailPage/GroupedDetailPage";
import ProductDetailPage from "containers/ProductDetailPage/ProductDetailPage";
import RefundsPage from "containers/Refunds/RefundsPage";
import SiteHeader from "containers/SiteHeader";
import { useEffect,useState } from "react";
import { Toaster } from "react-hot-toast";
import { BrowserRouter,Navigate,Route,Routes } from "react-router-dom";
import Footer from "shared/Footer/Footer";
import { useCollege } from "store/utils/hooks";
import { useLoadSessions } from "utils/session";
import ScrollToTop from "./ScrollToTop";
import { Page } from "./types";

export const pages: Page[] = [
  { path: "/", component: PageHome },
  { path: "/home2", component: () => <Navigate replace to="/" /> },
  { path: "/home3", component: () => <Navigate replace to="/" /> },
  { path: "/home-header-2", component: () => <Navigate replace to="/" /> },
  { path: "/product-detail", component: ProductDetailPage },
  { path: "/grouped-detail", component: GroupedDetailPage },
  { path: "/product-detail-2", component: () => <Navigate replace to="/product-detail" /> },
  //
  { path: "/page-collection-2", component: () => <Navigate replace to="/page-collection" /> },
  { path: "/page-collection", component: PageCollection },
  { path: "/page-search", component: PageSearch },
  { path: "/promotions", component: PagePromotions },
  //
  { path: "/account", component: AccountPage },
  { path: "/addresses", component: AccountAddresses },
  { path: "/students", component: AccountStudents },
  { path: "/account-wait-list", component: AccountSavelists },
  { path: "/account-change-password", component: AccountPass },
  { path: "/account-remove", component: AccountRemove },
  { path: "/account-billing", component: AccountBilling },
  { path: "/account-my-order", component: AccountOrder },
  //
  { path: "/refunds", component: RefundsPage },
  { path: "/cart", component: CartPage },
  { path: "/checkout", component: CheckoutPage },
  //
  { path: "/blog", component: BlogPage },
  { path: "/blog-single", component: BlogSingle },
  //
  { path: "/contact", component: PageContact },
  { path: "/about", component: PageAbout },
  { path: "/signup", component: PageSignUp },
  { path: "/login", component: PageLogin },
  { path: "/forgot-pass", component: PageForgotPassword },
  { path: "/subscription", component: PageSubcription },
  //
  { path: "/ok", component: OkPage },
  { path: "/ko", component: KoPage },
  //
  { path: "/ok-devolution", component: OkDevolutionPage },
  //
  { path: "/faqs", component: FaqsPage},
  { path: '/devolutions', component: () => <CommonPoliticsPage title="Devoluciones" politic="devolution"/> },
  { path: "/terms", component: () => <CommonPoliticsPage title="Términos y Condiciones" politic="terminos" /> },
  { path: "/privacy", component: () => <CommonPoliticsPage title="Política de privacidad" politic="privacidad" /> },
  { path: "/cookies", component: () => <CommonPoliticsPage title="Política de Cookies" politic="cookies" /> }
];

const RouterProvider = () => (
  <BrowserRouter>
    <Toaster />
    <ScrollToTop />
    <SiteHeader />
    <Routes>
      {pages.map(({ component: Component, path }, index) => {
        return <Route key={index} element={<Component />} path={path} />;
      })}
      <Route element={<Page404 />} />
    </Routes>
    <Footer />
    <CookieConsent />
  </BrowserRouter>
);

const CredentialsLoader = ({
  setIsPending,
}: {
  setIsPending: (isPending: boolean) => void;
}) => {
  const { isLoading } = useLoadSessions();
  useEffect(() => {
    setIsPending(isLoading);
  }, [isLoading]);
  return (
    <div className="w-screen h-screen flex items-center justify-center">
      {_renderLoading()}
    </div>
  );
};

const MyRoutes = () => {
  const college = useCollege();
  const [isPending, setIsPending] = useState<boolean>(false);
  return !college || isPending ? (
    localStorage.getItem("accessToken") ? (
      <CredentialsLoader setIsPending={setIsPending} />
    ) : (
      <CollegeSignUp />
    )
  ) : (
    <RouterProvider />
  );
};

export default MyRoutes;
